import { render, staticRenderFns } from "./SceneTable.vue?vue&type=template&id=5e45c165&scoped=true"
import script from "./SceneTable.vue?vue&type=script&lang=js"
export * from "./SceneTable.vue?vue&type=script&lang=js"
import style0 from "./SceneTable.vue?vue&type=style&index=0&id=5e45c165&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e45c165",
  null
  
)

export default component.exports